<ng-container *transloco="let t">
  <div class="backdrop">
    <div aria-live="polite" class="loading-content" role="status">
      <ess-loading-spinner color="black" />
      <p class="sans">
        {{ t('loading.default') }}
        <span>{{ t('itinerary.thisRequestCouldTakeAFewSeconds') }} </span>
      </p>
    </div>
  </div>
</ng-container>
